// extracted by mini-css-extract-plugin
module.exports = {"button":"AdsBackButton_button__LqOU4"};